"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDelete = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var Button_1 = __importDefault(require("../buttons/Button"));
var ModalDialog_1 = __importDefault(require("./ModalDialog"));
var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOpen = function () {
            var onOpen = _this.props.onOpen;
            if (onOpen) {
                onOpen();
            }
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        _this.handleCloseFromButton = function (event) {
            event.stopPropagation();
            _this.handleClose();
        };
        _this.handleAccept = function (event) {
            var onAccept = _this.props.onAccept;
            _this.setState({ open: false });
            onAccept(event);
        };
        _this.state = { open: props.startOpen || false };
        return _this;
    }
    Confirm.prototype.render = function () {
        var _a = this.props, _b = _a.accept, accept = _b === void 0 ? "Yes" : _b, appElement = _a.appElement, children = _a.children, className = _a.className, contentRef = _a.contentRef, danger = _a.danger, disclaimer = _a.disclaimer, entrance = _a.entrance, trigger = _a.trigger, width = _a.width, registerModal = _a.registerModal;
        var open = this.state.open;
        var classList = classnames_1.default("chq-cnf", className);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            trigger(this.handleOpen),
            open && (react_1.default.createElement(ModalDialog_1.default, { appElement: appElement, className: classList, contentRef: contentRef, entrance: entrance, width: width, onClose: this.handleClose, registerModal: registerModal },
                react_1.default.createElement(ModalDialog_1.default.Body, null,
                    children,
                    disclaimer && (react_1.default.createElement("div", { className: "chq-cnf-disclaimer" }, disclaimer))),
                react_1.default.createElement(ModalDialog_1.default.Footer, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Button_1.default, { inverted: true, onClick: this.handleCloseFromButton }, "Cancel")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Button_1.default, { autoFocus: true, primary: true, danger: danger, onClick: this.handleAccept }, accept)))))));
    };
    return Confirm;
}(react_1.default.Component));
exports.ConfirmDelete = function (props) { return (react_1.default.createElement(Confirm, __assign({ accept: "Delete", danger: true }, props))); };
exports.default = Confirm;
